import { ISystemProduct } from '../types';
import { HydraQueryParams, useHydraQuery } from './useHydraQuery';

export function useGetProductsQuery<D extends ISystemProduct[]>(params?: HydraQueryParams<D>) {
  const { vars, options } = params || {};
  return useHydraQuery<D>('getProducts', '/api/products', {
    vars,
    options,
  });
}
